// GERADO POR scripts/build-icons.js — não edite à mão.
// Fonte: handoff/assets/icons/selo-check.svg

import React, { useId } from 'react';

/** Proporção nativa 24x24. */
export default function IconeSeloCheck({ size = 24, color = 'currentColor', strokeWidth, className, title, ...rest }) {
  // id único por instância: sem isto, dois gradientes iguais colidem na mesma página
  const uid = useId().replace(/:/g, '');
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      <defs><linearGradient id={`g-${uid}`} x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#1428A0"></stop><stop offset="1" stopColor="#3A55E0"></stop></linearGradient></defs><circle cx="12" cy="12" r="12" fill={`url(#g-${uid})`}></circle><path d="M17 8.5 10.5 15 7 11.5" fill="none" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>
  );
}
